module.exports = __webpack_public_path__ + "img/na.bb49a403.svg";